import { Component, Input } from '@angular/core'
import { MenuItem } from 'primeng/api'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { BreadcrumbModule } from 'primeng/breadcrumb'
import { HtmlToTextPipe } from '../../pipes/html-to-text.pipe'

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, BreadcrumbModule, HtmlToTextPipe],
  templateUrl: './bread-crumb.html',
  styleUrl: './bread-crumb.scss'
})
export class BreadCrumb {
  @Input() items: MenuItem[] = []

  isLast(item: MenuItem): boolean {
    return this.items.indexOf(item) === this.items.length - 1
  }
}
